module.exports = __webpack_public_path__ + "static/img/banner1.4232e760.jpg";